import { Stack, styled } from '@mui/material'

import { COLORS, unit } from '@hcr/ui'

export const HeaderHomeContainer = styled(Stack)`
  padding: ${unit(6.5)} ${unit(5.5)};
  background-color: ${COLORS.burgundi[500]};
  color: ${COLORS.white};

  .MuiTypography-root {
    word-break: break-word;
  }
`
